var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filial-settings-view',{attrs:{"title":"Печать и фискализация","category":"print","hide-group-titles":""}})}
var staticRenderFns = []

export { render, staticRenderFns }